import React from 'react';
import { ACTIVE_TABS } from './constants';

export default function Abas({ activeTab = '', onTabChange }) {
  const options = [
    [ACTIVE_TABS.BILHETAGEM, 'Calculadoras e consultas'],
    [ACTIVE_TABS.OUTROS, 'Outros'],
  ];

  return (
    <div className="cd-pills" role="group" aria-label="Tipo de benefício">
      {options.map(([tab, label]) => (
        <button
          key={tab}
          type="button"
          className="cd-pill"
          aria-pressed={tab === activeTab}
          onClick={() => onTabChange(tab)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
